<template>
    <v-expansion-panel>
        <v-expansion-panel-content v-if="groupsBasket.length">
            <template v-slot:header>
                <h4>
                    <v-badge right overlap color="primary" class="mr-2">
                        <span slot="badge">{{ groups.length }}</span>
                        <v-icon>shopping_basket</v-icon>
                    </v-badge>
                    {{ title }}
                </h4>
            </template>
            <template>
                <v-layout row wrap class="mb-1 ml-3">
                    <v-chip v-for="group in groups" :key="`${$lodash.camelCase(group.name)}-${group.id}`"
                        @click="removeClose(group)" color="primary"
                        style="z-index: 0; max-width:auto; max-height:auto; " text-color="white" close
                        @input="removeClose(group)"> <strong
                            style="z index: 0; white-space: normal !important; word-wrap: break-word;">{{ group.name
                            }}</strong>
                    </v-chip>
                </v-layout>
            </template>
        </v-expansion-panel-content>
        <v-expansion-panel-content v-if="partsBasket.length">
            <template v-slot:header>
                <h4>
                    <v-badge right overlap color="primary" class="mr-2">
                        <span slot="badge">{{ partTypes.length }}</span>
                        <v-icon>shopping_basket</v-icon>
                    </v-badge>
                    {{ titlePart }}
                </h4>
            </template>
            <template>
                <v-layout row wrap class="mb-1 ml-3">
                    <v-chip v-for="part in partTypes" :key="`${$lodash.camelCase(part.name)}-${part.id}`"
                        @click="removeClose(part)" color="primary" style="z-index: 0; max-width:auto; max-height:auto; "
                        text-color="white" close @input="removeClose(part)"> <strong
                            style="z index: 0; white-space: normal !important; word-wrap: break-word;">{{ part.name
                            }}</strong>
                    </v-chip>
                </v-layout>
            </template>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "CatalogBasket",
    props: {
        groups: {
            type: Array,
            required: true
        },
        partTypes: {
            type: Array,
            required: true
        },
        title: {
            type: String
        },
        titlePart: {
            type: String
        },
        model: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState({
            groupsBasket: state => state.parts.groupsBasket,
            partsBasket: state => state.parts.partsBasket,
            selected_parts_count: state => state.parts.selected_count,
        }),
    },
    methods: {
        removeClose(group) {
            this.$emit('Update', { model: this.model, group })
        },
    }
};
</script>